<template>
  <footer>
    <div class="footer-content">
      <div class="footer-section">
        <h4>Feed Lead</h4>
        <p>AI-powered outbound sales automation platform</p>
      </div>
      <div class="footer-section">
        <h4>Contact</h4>
        <p>info@feedlead.ai</p>
        <p>+1 (555) 123-4567</p>
      </div>
      <div class="footer-section">
        <h4>Links</h4>
        <a href="#">Blog</a>
        <a href="#">Careers</a>
        <a href="#">Privacy Policy</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>

<style scoped>
footer {
  padding: 4rem 2rem;
  background: #1f2937;
  color: white;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
}

.footer-section h4 {
  margin-bottom: 1rem;
}

.footer-section a {
  color: white;
  text-decoration: none;
  display: block;
  margin: 0.5rem 0;
}
</style> 